import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ProductCard from '../components/ProductCard';
import ProductModal from '../components/ProductModal';
import { openModal } from '../components/Modal';
import Slider from '../components/Slider';
import { selectPreviewProduct } from '../actions/action';

import graphic from '../assets/images/graphic.png';

const SampleNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div className={className} onClick={onClick} aria-hidden>
      <i className="icon-arrow-right" />
    </div>
  );
};

const SamplePrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div className={className} onClick={onClick} aria-hidden>
      <i className="icon-arrow-left" />
    </div>
  );
};

const mapStateToProps = ({ products, allPage, settings }) => {
  const setting = _.find(allPage, p => (p.slug === 'products'));
  // const filterAccessories = _.partition(products, i => _.get(i, 'acf.is_accessories', false));
  // const accessoryItems = _.head(filterAccessories);
  // const productItems = _.last(filterAccessories);
  // const otherProduct = _.get(settings, 'other_product', {});
  // const allProduct = [...productItems];
  // const productSection = _.find(
  //   // allPage,
  //   _.get(allPage, 'en'),
  //   page => _.get(page, 'slug') === 'products'
  // );
  // return {
  //   // key,
  //   productSection: {
  //     title: _.get(productSection, 'title.rendered'),
  //     allProduct,
  //     otherProduct,
  //     accessoryItems: _.head(accessoryItems)
  //   },
  //   otherProduct,
  //   allProduct: [...productItems, ...accessoryItems],
  //   setting,
  // };
  const data = _.map(products, (item, key) => {
    const filterAccessories = _.partition(item, i => _.get(i, 'acf.is_accessories', false));
    const accessoryItems = _.head(filterAccessories);
    const productItems = _.last(filterAccessories);
    const otherProduct = _.get(settings, 'other_product', {});
    const allProduct = [...productItems];
    const productSection = _.find(
      // allPage,
      _.get(allPage, key),
      page => _.get(page, 'slug') === 'products'
    );
    // console.log('++++++++++++++++++', productSection);
    return {
      key,
      productSection: {
        title: _.get(productSection, 'title.rendered'),
        allProduct,
        otherProduct,
        accessoryItems: _.head(accessoryItems)
      },
      otherProduct,
      allProduct: [...productItems, ...accessoryItems],
      // setting,
    };
  });
  return {
    content: _.keyBy(data, 'key'),
    setting,
  };
};

const actions = { selectPreviewProduct };

const mapDispatchToProps = (dispatch) => {
  return { actions: bindActionCreators(actions, dispatch) };
};

const dataSource1 = [
  {
    title: '57th Bangkok Gold & Jewelry Fair 2016',
    id: 'aaa',
    img: 'https://source.unsplash.com/collection/190727/1440x640'
  },
  {
    title: '58th Bangkok Gold & Jewelry Fair 2016',
    id: 'bbb',
    img: 'https://source.unsplash.com/user/erondu/1440x640'
  }
];

class Products extends Component {
  state = {
    currentProduct: {}
  };
  handleOnClickProduct(product) {
    // console.log('handleOnClickProduct', product);
    this.props.actions.selectPreviewProduct(product);
    openModal('modal-preview-gallery');
  }
  renderGallery = () => {
    const { setting } = this.props;
    const gallery = _.get(setting, 'acf.banners.gallery', []);

    return (
      <div className="wrape-product-slider col-12 no-gutters">
        <Slider
          className="product-slider"
          settings={{
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />,
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  arrows: false
                }
              }
            ]
          }}
          itemList={gallery}
          uiRenderer={({ url }, index) => (
            <img src={url} alt="" />
          )}
        />
      </div>
    );
  }
  render() {
    const { currentProduct } = this.state;
    // const { allProduct, otherProduct, getContentLanguage, productSection, content, language } = this.props;
    // const sortProduct = _.orderBy(allProduct, ['acf.is_new_arrival'], ['desc']);

    const { getContentLanguage, content, language } = this.props;
    const allProduct = _.get(content, `${language}.allProduct`);
    const otherProduct = _.get(content, `${language}.otherProduct`);
    const productSection = _.get(content, `${language}.productSection`);
    const sortProduct = _.orderBy(allProduct, ['acf.is_new_arrival'], ['desc']);
    // console.log('reder1', content);
    // console.log('reder2', productSection);
    // console.log('reder3', sortProduct);
    // console.log('reder4', currentProduct);
    return (
      <div className="products">
        <div className="product-bg">
          <div className="bg-top" />
          <div className="graphic col-3">
            <img src={graphic} alt="" />
          </div>
          <div className="graphic g-bottom col-3">
            <img src={graphic} alt="" />
          </div>
        </div>
        <div className="products-content row no-gutters">
          {this.renderGallery()}
          <div className="offset-1 col-10">
            <h2 className="darkGray m-bottom-40 title">{_.get(productSection, 'title', 'PRODUCTS')}</h2>

            <div className="row custom-gutter products-container">
              {_.map(sortProduct, (data, index) => {
                let className = 'wrap-product-card col-12 col-sm-12 col-md-6 col-lg-4';
                let productClassName = 'home -main';
                let main = false;
                if (index === 0) {
                  className = 'wrap-product-card col-12';
                  productClassName = 'head-product';
                  main = true;
                }
                return (
                  <div key={`${data.id}-${index}`} className={className}>
                    <ProductCard
                      className={productClassName}
                      img={_.get(data, [
                        'acf',
                        'cover_image',
                        'url',
                      ])}
                      main={main}
                      title={`${_.get(data, ['title', 'rendered'])}`}
                      // title={_.get(data, ['title', 'rendered'])}
                      subTitle={_.get(data, ['acf', 'product_code'])}
                      onClick={() => this.handleOnClickProduct(data)}
                    />
                  </div>
                );
              })}
              <div className="wrap-product-card col-product col-12 col-sm-12 col-md-6 col-lg-4">
                <a href={_.get(otherProduct, 'url')}>
                  <ProductCard
                    titleBottom={_.get(otherProduct, 'text')}
                    img={_.get(otherProduct, 'image.url')}
                    main={false}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        {
          <ProductModal
            // images={_.get(currentProduct, 'acf.gallery')}
            name="modal-preview-gallery"
            // data={currentProduct}
            getContentLanguage={getContentLanguage}
            language={language}
            // initialSlide={initPreview}
          />
        }
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Products);



// WEBPACK FOOTER //
// ./src/screens/Products.js